module.exports = [{
      plugin: require('/Users/kolber/Sites/_github/today/today-site/frontend/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Today","short_name":"Today","start_url":"/","background_color":"#fff","theme_color":"#000","display":"minimal-ui","icon":"src/assets/images/favicon.png"},
    },{
      plugin: require('/Users/kolber/Sites/_github/today/today-site/frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
